import {banIcon} from "@/utils/iconUtils";


export const rawDataStatusIconList={
    'NO_DATA':{
        iconClass: 'my-icon',
        displayName: '无',
        class: 'status-tag tag-none',
        colorClass:'tag-none',
        isMyIcon:true,
        myIcon:banIcon

    },'NOT_RELEASED':{
        iconClass: 'el-icon-lock',
        displayName: '未释放',
        class: 'status-tag tag-unreleased',
        colorClass:'tag-unreleased'
    },
    'LINK_RELEASED':{
        iconClass: 'el-icon-link',
        displayName: '链接释放',
        class: 'status-tag tag-link-released',
        colorClass:'tag-link-released'

    },
    'HDD_RELEASED':{
        iconClass: 'el-icon-folder',
        displayName: '硬盘释放',
        class: 'status-tag tag-disk-released',
        colorClass:'tag-disk-released'
    }
}
